import type { GetServerSidePropsContext } from 'next';

export interface IRedirectProps {
  permanent: boolean,
  destination: string,
}
export interface IRedirectResponse {
  props: {
    redirect: IRedirectProps,
  },
}

export const pageNotFound = () => ({
  props: {
    notFound: true,
  },
});

// The page renders props.errorCode itself, e.g. with next/error.
export const pageServiceUnavailable = (res: GetServerSidePropsContext['res']) => {
  res.statusCode = 503;

  return {
    props: {
      errorCode: 503,
    },
  };
};

export const pageRedirectTo = (url = '', permanent = false): IRedirectResponse => ({
  props: {
    redirect: {
      permanent,
      destination: url,
    },
  },
});
